<template>
  <EmailYjsftj />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
